module.exports = __webpack_public_path__ + "static/media/sfx_ui_close_kid_area.1dc30e3e.mp3";